<template>
  <modal-box class="stake-modal" :title="'Unstake in Pool'">
    <template #body>
      <p class="body-header section">
        <span class="label">Unstake:</span>
        <span class="unit"
          ><img
            src="/assets/sf/image/icon_grad.png"
            class="body-header__icon"
          />CAKE-LP Tokens</span
        >
      </p>
      <div class="value section">
        <p class="value__avaliable">
          {{ toFormattedToken(available) }} CAKE-LP Tokens Avaliable
        </p>
        <p class="value__amount">{{ toFormattedToken(amount) }}</p>
      </div>
      <div class="input section">
        <input
          ref="range"
          class="input__input"
          type="range"
          min="0"
          max="100"
          v-model="percentage"
        />
        <span
          class="input__label"
          :style="{ marginLeft: rangePosition + 'px' }"
          >{{ percentage }}</span
        >
        <div
          class="input__bar"
          :style="{ width: rangePosition + 10 + 'px' }"
        ></div>
      </div>
      <div class="set-value section">
        <input-button :size="'small'" :type="'common'" @click="setValue(25)"
          >25%</input-button
        >
        <input-button :size="'small'" :type="'common'" @click="setValue(50)"
          >50%</input-button
        >
        <input-button :size="'small'" :type="'common'" @click="setValue(75)"
          >75%</input-button
        >
        <input-button :size="'small'" :type="'common'" @click="setValue(100)"
          >MAX</input-button
        >
      </div>
    </template>

    <template #footer>
      <div class="footer-button">
        <input-button :size="'large'" :type="'common'" @click="closeModal"
          >Cancel</input-button
        >
        <input-button
          :size="'large'"
          :is-loading="isLoading"
          :disabled="isUnconfirmable"
          @click="onConfirm"
          >{{ isLoading ? "Confirming" : "Confirm" }}</input-button
        >
      </div>
    </template>
  </modal-box>
</template>

<script>
import InputButton from "@/components/atoms/InputButton";
import ModalBox from "@/components/molecules/ModalBox";
import { getPools } from "@/utils/boilerCakeLpFarming";
import numFormat from "number-format.js";
import cakeLpFarmingPools from "@/domain/boilerCakeLpFarming/pools";

export default {
  name: "BoilerCakelpFarmingUnstakeModal",
  components: {
    InputButton,
    ModalBox,
  },
  data() {
    return {
      isLoading: false,
      percentage: 0,
      inputElementWidth: 0,
      checkStatusInterval: null,
    };
  },
  computed: {
    isUnconfirmable() {
      return this.web3.instance.utils
        .toBN(this.amount)
        .eq(this.web3.instance.utils.toBN(0));
    },
    available() {
      return this.max;
    },
    amount() {
      if (this.percentage == 100) {
        return this.available;
      }

      return this.web3.instance.utils
        .toBN(this.available)
        .mul(this.web3.instance.utils.toBN(this.percentage))
        .mul(this.web3.instance.utils.toBN(100))
        .div(this.web3.instance.utils.toBN(10000))
        .toString();
    },
    usdtRate() {
      return this.web3.instance.utils.toBN(1.12).toString();
    },
    usdt() {
      return this.web3.instance.utils
        .toBN(this.amount)
        .mul(this.web3.instance.utils.toBN(this.usdtRate))
        .toString();
    },
    rangePosition() {
      return (this.percentage * (this.inputElementWidth - 20)) / 100;
    },
    withdraw() {
      return this.$store.state.withdraw;
    },
    min() {
      return `${0}`;
    },
    max() {
      return this.web3.instance.utils
        .toBN(this.withdraw.stakingPool.account.staked)
        .toString();
    },
    account() {
      return this.$store.state.account;
    },
    web3() {
      return this.$store.state.web3;
    },
  },
  methods: {
    toFormattedToken(num) {
      return numFormat(
        "#,##0.00000",
        this.web3.instance.utils.fromWei(num, "ether")
      );
    },
    onConfirm() {
      this.isLoading = true;

      const abi = cakeLpFarmingPools.find(
        (pool) =>
          pool.contractAddress == this.withdraw.stakingPool.stakeContractAddress
      ).abi;

      const stakingPoolContract = new this.web3.instance.eth.Contract(
        abi,
        this.withdraw.stakingPool.stakeContractAddress
      );

      stakingPoolContract.methods
        .withdraw(this.amount)
        .send({ from: this.account.address })
        .on("transactionHash", (transactionHash) => {
          this.checkTransactionStatus(transactionHash, 10);
        })
        .on("error", () => {
          this.incompleteTransaction();
        });
    },
    checkTransactionStatus(transactionHash, seconds) {
      this.checkStatusInterval = setInterval(() => {
        this.web3.instance.eth
          .getTransactionReceipt(transactionHash)
          .then((result) => {
            if (result) {
              if (result.status) {
                clearInterval(this.checkStatusInterval);
                this.completeTransaction();
              }
            }
          });
      }, seconds * 1000);
    },
    completeTransaction() {
      getPools(this.web3.instance, this.account.address).then((result) => {
        this.$store.dispatch("boilerCakeLpFarmings/updatePools", result);

        this.isLoading = false;
        this.$store.dispatch("closeModal");

        this.$store.dispatch("toast/updateToast", {
          type: "success",
          title: "Unstaked!",
          message: `Your ${this.withdraw.stakingPool.rewardTokenSymbol} earnings have also been harvested to your wallet!`,
        });
      });
    },
    incompleteTransaction() {
      this.isLoading = false;
      this.$store.dispatch("closeModal");

      this.$store.dispatch("toast/updateToast", {
        type: "error",
        title: "Canceled",
        message: "Please try again and confirm the transaction.",
      });
    },
    closeModal() {
      this.$store.dispatch("closeModal");
    },
    setValue(value) {
      this.percentage = value;
    },
  },
  mounted() {
    this.inputElementWidth = this.$refs.range.clientWidth;
  },
  beforeDestroy() {
    clearInterval(this.checkStatusInterval);
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
.stake-modal {
  padding-left: 28px;
  padding-right: 28px;
}

.section {
  margin-bottom: 48px;
}
.body-header {
  display: flex;
  flex-wrap: wrap;
  -webkit-box-pack: justify;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  font-size: 1.6rem;
  .unit {
    text-align: right;
  }
  &__icon {
    width: 24px;
    margin-right: 8px;
  }
}
.value {
  background-color: #f7f5fc;
  color: rgb(153, 142, 181);
  border-radius: 6px;
  text-align: right;
  padding: 3% 5%;

  &__avaliable {
    font-size: 1.1rem;
    line-height: 1.5rem;
  }
  &__amount {
    font-size: 2rem;
    line-height: 2rem;
  }
  &__usdt {
    font-size: 1.1rem;
    line-height: 1.5rem;
  }
}
.input {
  &__input {
    width: 100%;
    -webkit-appearance: none;
    margin: 0;
    padding: 0;
    display: block;
    background: #aaa;
    border-radius: 3px;
    height: 8px;
    &::-webkit-slider-thumb {
      box-shadow: none;
      border: none;
      height: 40px;
      width: 40px;
      background-color: transparent;
      cursor: pointer;
      -webkit-appearance: none;
      margin-top: -30px;
      background-image: url(/assets/sf/image/wave.png);
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }
  }
  &__bar {
    background-color: #36c9e0;
    width: 0%;
    left: 0;
    height: 8px;
    top: 50%;
    margin-top: -38px;
    display: block;
    z-index: 10;
    border-radius: 8px 0 0 8px;
  }
  &__label {
    font-size: 1.2rem;
    &::after {
      content: "%";
    }
  }
}
.set-value {
  display: flex;
  gap: 8px;
}
.footer-button {
  display: flex;
  gap: 12px;
}
</style>